import * as Html from "../util/Html.ts";
Html.registerWidget('widget/list-sharing-controller',{initDom})

export function initDom(div: HTMLElement){
  const select = div.querySelector("select") as HTMLSelectElement;
  const selectedValue = select.getAttribute("data-fw-select-value");
  const sharedToAll = div.querySelector("input[name='sharedToAll']") as HTMLInputElement;
  const explain = div.querySelectorAll<HTMLElement>("[data-ontype]");
  const details = div.parentElement?.querySelector('[data-widget="widget/user-picker"]') as HTMLElement;

  const goodOption = select.querySelector<HTMLOptionElement>("option[value='"+selectedValue+"']");
  if(goodOption){
    goodOption.setAttribute('selected','selected');
  }

  select.addEventListener('change',function(){
    if(this.value==='all'){
      sharedToAll.value = 'true';
      details.style.display = 'none';
      details.dispatchEvent(new Event('clear'))
    }else if(this.value==='none'){
      sharedToAll.value = 'false';
      details.style.display = 'none';
      details.dispatchEvent(new Event('clear'))
    }else{
      sharedToAll.value = 'false';
      details.style.display = 'block';
    }
    explain.forEach(element => {
      element.style.display = element.getAttribute('data-ontype')===this.value?'block':'none';

    })
  })
  select.dispatchEvent(new Event('change'))
  
  
}